import React, { createContext, useContext, useState, useEffect } from 'react';

const MobileMenuContext = createContext();

export const useMobileMenu = () => {
  const context = useContext(MobileMenuContext);
  if (!context) {
    throw new Error('useMobileMenu must be used within a MobileMenuProvider');
  }
  return context;
};

export const MobileMenuProvider = ({ children }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  // Desktop sidebar starts collapsed (icon-only) on every fresh load; the
  // user expands it with the toggle button when they want to see labels.
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(true);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const openMobileMenu = () => {
    setIsMobileMenuOpen(true);
  };

  const toggleSidebarCollapsed = () => {
    setIsSidebarCollapsed((prev) => !prev);
  };

  const expandSidebar = () => {
    setIsSidebarCollapsed(false);
  };

  return (
    <MobileMenuContext.Provider
      value={{
        isMobileMenuOpen,
        toggleMobileMenu,
        closeMobileMenu,
        openMobileMenu,
        isSidebarCollapsed,
        toggleSidebarCollapsed,
        expandSidebar,
      }}
    >
      {children}
    </MobileMenuContext.Provider>
  );
};
